import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { registrationPage3Request, registrationPage3Success, registrationPage3Failure } from '../reducers/login';
import { xapiRequest } from '../reducers/xapi';
import { API_LINK } from '../../constants';
import * as moment from 'moment';
const API = `${API_LINK}api/registerPage4`;

function* registrationPage3FunctionAxios() {
 
  const state = yield select(fullState => fullState);
  
  const {

    conMunicipalAreaID,
    conProvinceID,
    urbanRural,
    address,
    city,
    code2,
    code,
  } = state.form.registration.values;
  
  const amLeader =  0;
  const dob = moment(state.form.registration.values.birthdate).format('YYYY-MM-DD')
  const { userId } = state.loginReducer.user;
  const { saAreaCode } = state.viewReducer;
  var p = conProvinceID;
  
  if( Array.isArray(p)){
    p = conProvinceID[0];
  }
  var m = conProvinceID;
  
  if( Array.isArray(m)){
    m = conMunicipalAreaID[0];
  }
  const response = yield call(() => {
    return axios({
      method: 'post',
      url: API+'/'+userId,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        conMunicipalAreaID:conMunicipalAreaID[0],
        conProvinceID: conProvinceID[0],
        address: address,
        city: city,
        urbanRural: urbanRural[0],
        saAreaCode: saAreaCode,
        code: code,
        platform: 'web'
      },
    });
  });
  
  return response;
}

function* workerRegistrationPage3Saga() {
  try {
    const response = yield call(registrationPage3FunctionAxios);
    const responseFromLogin = response.data;

    if (response.status === 200) {
      yield put(registrationPage3Success(responseFromLogin));
      yield put(xapiRequest({ xapiType: 'Registration 3' }));
    }

    if (response.status === 205) {
      yield put(registrationPage3Failure('Email does not exist'));
    }
    if (response.status === 206) {
      yield put(registrationPage3Failure(response.data));
    }
    if (response.status === 208) {
      yield put(registrationPage3Failure(response.data));
    }
    if (response.status === 500) {
      yield put(registrationPage3Failure(response.statusText));
    }
  } catch (error) {
    
    yield put(registrationPage3Failure(error));
  }
}

export function* watcherRegistrationPage3Saga() {
  yield takeLatest(registrationPage3Request().type, workerRegistrationPage3Saga);
}
